import { getAnonymousId, getResolution } from "@outschool/ui-utils";
import {
  AnalyticsPluginRestProxyTrackArgs,
  EXPERIMENT_TRIGGERS_INTAKE_TOPIC,
  RestProxyBrowserClient,
} from "@outschool/event-tracking-client";

import pkg from "./pkg.js";
import * as uuid from "uuid";

import type {
  SendEventOptions,
  SendEventResult,
} from "@outschool/event-tracking-client";

export enum EVENT_SOURCE {
  BROWSER = "browser",
  CLOUDFLARE_WORKER = "cloudflare-worker",
  SERVER = "server",
  SSR = "ssr",
}

let restProxyClient: RestProxyBrowserClient | undefined;

function getRestProxyClient() {
  if (!restProxyClient) {
    restProxyClient = new RestProxyBrowserClient({
      endpoint: pkg.EVENT_TRACKING_ENDPOINT,
    });
  }

  return restProxyClient;
}

function getBrowserEventTrackArgs(
  payload: any,
): AnalyticsPluginRestProxyTrackArgs {
  const resolution = getResolution();

  return {
    event: {
      id: uuid.v4(),
      anonymous_id: getAnonymousId(),
      client_version: pkg.CLIENT_VERSION,
      git_commit_id: pkg.GIT_COMMIT_SHA,
      original_timestamp: new Date().toISOString(),
      resolution_height: resolution.height,
      resolution_is_mobile: resolution.isMobile,
      resolution_width: resolution.width,
      ...payload,
    },
    topic: EXPERIMENT_TRIGGERS_INTAKE_TOPIC,
  };
}

function getEventTrackArgs(payload: any): AnalyticsPluginRestProxyTrackArgs {
  return {
    event: {
      id: uuid.v4(),
      git_commit_id: pkg.GIT_COMMIT_SHA,
      original_timestamp: new Date().toISOString(),
      ...payload,
    },
    topic: EXPERIMENT_TRIGGERS_INTAKE_TOPIC,
  };
}

export async function sendExperimentTriggerThroughEventTracking(
  payload: any,
  eventSource: EVENT_SOURCE,
): Promise<SendEventResult> {
  if (!pkg.initialized) {
    throw new Error(
      "Experiments-Shared Package needs to be initialized first in order to utilize this functionality.",
    );
  }

  const client = getRestProxyClient();

  let event: AnalyticsPluginRestProxyTrackArgs;
  if (
    eventSource === EVENT_SOURCE.SERVER ||
    eventSource === EVENT_SOURCE.CLOUDFLARE_WORKER
  ) {
    event = getEventTrackArgs({
      event_source: eventSource,
      ...payload,
    });
  } else {
    event = getBrowserEventTrackArgs({
      event_source: eventSource,
      ...payload,
    });
  }

  const options: SendEventOptions = {};
  if (eventSource === EVENT_SOURCE.CLOUDFLARE_WORKER) {
    options.skipCredentials = true;
  }

  return await client.sendEvent(event, options);
}
